



import Vue, { PropType } from "vue";
import { OverallTrendsMaxAndMin } from "@/features/home/types";
import VueApexCharts from "vue-apexcharts";
import { getCurrencySign } from "@/commons/utils/currencySign";

type OverallTrendsChartData = {
  labels: string[];
  revenue: number[];
  impression: number[];
};

export default Vue.extend({
  components: {
    apexchart: VueApexCharts,
  },
  data: () => ({
    series: [] as { name: string; data: number[] }[],
    options: {},
  }),
  created() {
    this.updateData();
  },
  props: {
    chartData: { type: Object as PropType<OverallTrendsChartData> },
    chartDataMaxAndMin: { type: Object as PropType<OverallTrendsMaxAndMin> },
  },
  methods: {
    updateData() {
      this.series = [
        {
          name: "Revenue",
          data: this.chartData.revenue,
        },
        {
          name: "Impression",
          data: this.chartData.impression,
        },
      ];
      this.options = {
        width: "100%",
        chart: {
          type: "line",
          zoom: {
            enabled: false,
          },
          animations: {
            enabled: false,
          },
          toolbar: {
            show: false,
          },
        },
        colors: ["#289CF1", "#3DD47A"],
        dataLabels: {
          enabled: false,
        },
        stroke: {
          width: 1,
          curve: "smooth",
        },
        legend: {
          position: "top",
          fontSize: "10px",
          markers: {
            width: 10,
            height: 10,
          },
        },
        markers: {
          size: 2,
          strokeWidth: 0,
          hover: {
            sizeOffset: 2,
          },
        },
        grid: {
          borderColor: "#EAEAEA",
          yaxis: {
            lines: {
              show: false,
            },
          },
          xaxis: {
            lines: {
              show: true,
            },
          },
        },
        labels: this.chartData.labels,
        yaxis: [
          {
            tickAmount: 7,
            max: this.chartDataMaxAndMin.revenue.max * 1.2,
            min: this.chartDataMaxAndMin.revenue.min * 0.8,
            forceNiceScale: true,
            title: {
              text: "Revenue",
              style: {
                fontSize: "10px",
                fontColor: "#000000DE",
              },
            },
            labels: {
              formatter: (value: any) => {
                if (value !== null) {
                  return getCurrencySign() + Number(value).toLocaleString();
                } else {
                  return "--";
                }
              },
            },
          },
          {
            tickAmount: 7,
            max: this.chartDataMaxAndMin.impression.max * 1.2,
            min: this.chartDataMaxAndMin.impression.min * 0.8,
            forceNiceScale: true,
            opposite: true,
            title: {
              text: "Impression",
              style: {
                fontSize: "10px",
                fontColor: "#000000DE",
              },
            },
            labels: {
              formatter: function (value: any) {
                if (value !== null) {
                  return Number(value)
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
                } else {
                  return "--";
                }
              },
            },
          },
        ],
        xaxis: {
          labels: {
            style: { fontSize: "10px" },
          },
        },
      };
    },
  },
});
